var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    id: "memory-compass-north-arrow",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H10V5.5H11V8H12V4H14V14H12V12H11V10H10V14H8M10 17V16H12V17H13V18H14V19H15V20H16V22H14V21H13V20H12V19H10V20H9V21H8V22H6V20H7V19H8V18H9V17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlack);
export default __webpack_public_path__ + "static/media/black.fd161d17a3824d90ec01465b13060c94.svg";
export { ForwardRef as ReactComponent };